// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2MEBS","head":"ProcedureTableInfo_head__2TF__"};